export default __webpack_public_path__ + "static/media/service-startup-icon.31fee117.svg";